import { all, fork, put, takeLatest } from "redux-saga/effects";
import API from "../../utils/API";
import * as actionType from "./actionTypes";
import { toast } from "react-toastify";

function* getAllDocumentationsSaga() {
  try {
    yield put({ type: actionType.SET_DOCUMENTATION_LOADING });
    const { data } = yield API.get("api/instruction");
    yield put({
      type: actionType.GET_ALL_DOCUMENTATIONS_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    yield put({ type: actionType.GET_ALL_DOCUMENTATIONS_FAILURE });
  }
}

function* getDocumentByIdSaga({ id }) {
  try {
    yield put({ type: actionType.SET_DOCUMENTATION_LOADING });
    const { data } = yield API.get(`api/instruction/${id}`);
    yield put({
      type: actionType.GET_DOCUMENT_BY_ID_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    yield put({ type: actionType.GET_DOCUMENT_BY_ID_FAILURE });
  }
}

function* createDocumentSaga({ payload }) {
  try {
    yield put({ type: actionType.SET_DOCUMENTATION_LOADING });
    const { data } = yield API.post(`api/instruction`, payload);
    toast.success(data?.message || "Document created successfully");
    yield put({ type: actionType.CREATE_DOCUMENT_SUCCESS });
    yield put({ type: actionType.GET_ALL_DOCUMENTATIONS, id: data.data._id });
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    yield put({ type: actionType.CREATE_DOCUMENT_FAILURE });
  }
}

function* updateDocumentSaga({ id, payload }) {
  try {
    yield put({ type: actionType.SET_DOCUMENTATION_LOADING });
    const { data } = yield API.put(`api/instruction/${id}`, payload);
    toast.success(data?.message || "Document updated successfully");
    yield put({ type: actionType.UPDATE_DOCUMENT_BY_ID_SUCCESS });
    yield put({ type: actionType.GET_ALL_DOCUMENTATIONS, id });
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    yield put({ type: actionType.UPDATE_DOCUMENT_BY_ID_FAILURE });
  }
}

function* deleteDocumentSaga({ id, resp }) {
  try {
    yield put({ type: actionType.SET_DOCUMENTATION_LOADING });
    const { data } = yield API.delete(`api/instruction/${id}`);
    toast.success(data?.message || "Document deleted successfully");
    yield put({ type: actionType.DELETE_DOCUMENT_BY_ID_SUCCESS });
    resp && resp(data);
    yield put({ type: actionType.GET_ALL_DOCUMENTATIONS });
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    yield put({ type: actionType.DELETE_DOCUMENT_BY_ID_FAILURE });
  }
}

function* exportDocumentSaga() {
  try {
    yield put({ type: actionType.SET_DOCUMENTATION_LOADING });
    const { data } = yield API.get(`api/instruction/export/json`);
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "Notes.json";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadLink.href);
    toast.success(data?.message || "Notes exported successfully");
    yield put({ type: actionType.EXPORT_DOCUMENTS_SUCCESS });
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    yield put({ type: actionType.EXPORT_DOCUMENTS_FAILURE });
  }
}

function* importDocumentSaga({ payload }) {
  try {
    yield put({ type: actionType.SET_DOCUMENTATION_LOADING });
    const { data } = yield API.post(`api/instruction/import/json`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
    toast.success(data?.message || "Document imported successfully");
    yield put({ type: actionType.IMPORT_DOCUMENTS_SUCCESS });
    yield put({ type: actionType.GET_ALL_DOCUMENTATIONS });
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    yield put({ type: actionType.IMPORT_DOCUMENTS_FAILURE });
  }
}

export function* watchGetAllDocumentations() {
  yield takeLatest(actionType.GET_ALL_DOCUMENTATIONS, getAllDocumentationsSaga);
}
export function* watchGetDocumentById() {
  yield takeLatest(actionType.GET_DOCUMENT_BY_ID, getDocumentByIdSaga);
}
export function* watchCreateDocumentation() {
  yield takeLatest(actionType.CREATE_DOCUMENT, createDocumentSaga);
}
export function* watchUpdateDocumentById() {
  yield takeLatest(actionType.UPDATE_DOCUMENT_BY_ID, updateDocumentSaga);
}
export function* watchDeleteDocumentation() {
  yield takeLatest(actionType.DELETE_DOCUMENT_BY_ID, deleteDocumentSaga);
}
export function* watchExportDocumentation() {
  yield takeLatest(actionType.EXPORT_DOCUMENTS, exportDocumentSaga);
}
export function* watchImportDocumentation() {
  yield takeLatest(actionType.IMPORT_DOCUMENTS, importDocumentSaga);
}

function* DocumentationSaga() {
  yield all([
    fork(watchGetAllDocumentations),
    fork(watchGetDocumentById),
    fork(watchCreateDocumentation),
    fork(watchUpdateDocumentById),
    fork(watchDeleteDocumentation),
    fork(watchExportDocumentation),
    fork(watchImportDocumentation),
  ]);
}

export default DocumentationSaga;
